export default {
  styleOverrides: {
    root: {
      width: '100% !important',
      minWidth: '300px',
      marginTop: '12px !important',
      marginBottom: '12px !important',
      '& .MuiOutlinedInput-root': {
        minHeight: '56px !important',
        width: '100% !important',
        '& fieldset': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
        },
        '&:hover fieldset': {
          borderColor: 'rgba(0, 0, 0, 0.87)',
        },
        '&.Mui-focused fieldset': {
          borderWidth: '2px',
        }
      },
      '& .MuiInputLabel-root': {
        fontSize: '1rem',
        '&.Mui-focused': {
          fontSize: '0.875rem',
        }
      },
      '& .MuiOutlinedInput-input': {
        padding: '16.5px 14px !important',
        fontSize: '1rem',
        lineHeight: '1.4375em',
        width: '100% !important',
        boxSizing: 'border-box'
      }
    }
  }
};
